import React from "react";
import { Helmet } from "react-helmet-async";
import LoginModule from "app/components/LoginModule";
import { useAutoLogin } from "app/routes/Login/hooks";
import LoaderCentered from "app/components/Loader/LoaderCentered";
import styles from "./styles.module.scss";

const Login: React.FC = () => {
  const { isAutoLoginAttempt } = useAutoLogin();

  return (
    <div className={styles.wrapper}>
      <Helmet title="Login | Online Dance Classes and Tutorials" />
      {isAutoLoginAttempt ? <LoaderCentered /> : <LoginModule />}
    </div>
  );
};

export default Login;
